import { MapperService } from "./mapper-services";
import { Injectable } from "@angular/core";
import { QuotationResponse } from "../interfaces/financial-simulator/quotation-response.interface";
import { FinancialData } from "../interfaces/data/financial-data.interface";

@Injectable({
    providedIn: 'root',
})
export class QuotationReverseMapperService extends MapperService<QuotationResponse, FinancialData>  {

    protected map(entity: QuotationResponse): FinancialData {

        return {
            channel: '', //No lo devuelve, se mapea a posteriori
            secureCode:  entity.quotations[0].customerCpiPlanDetail?.cpiProduct.id,
            price: entity.toBeFinancedElement.totalGrossAmount,
            nominalRate: entity.quotations[0].nominalRate,
            aprcRate: entity.quotations[0].aprcRate,
            amountFinanced: entity.quotations[0].totalGrossAmount,
            totalInterestGrossAmount: entity.quotations[0].interestTotalGrossAmount,
            totalCreditCostInsurance: entity.toBeFinancedElement.totalCreditCost,
            totalCreditCost: (entity.toBeFinancedElement.totalCreditCost ? entity.toBeFinancedElement.totalCreditCost : 0)
                - (entity.toBeFinancedElement.secureCost ? entity.toBeFinancedElement.secureCost : 0),
            totalAmountDueInsurance: entity.quotations[0].installmentAndInterestTotalGrossAmount,
            totalAmountDue: entity.quotations[0].installmentAndInterestTotalGrossAmount
                - (entity.toBeFinancedElement.secureCost ? entity.toBeFinancedElement.secureCost : 0),
            installmentFirstGrossAmount: entity.quotations[0].installmentFirstGrossAmount,
            installmentLastGrossAmount: entity.quotations[0].installmentLastGrossAmount,
            installmentMonthlyGrossAmount: entity.quotations[0].installmentGrossAmount,
            installmentTotalGrossAmount: (entity.quotations[0].financedTotalGrossAmount ? entity.quotations[0].financedTotalGrossAmount : 0)
            - (entity.toBeFinancedElement.secureCost ? entity.toBeFinancedElement.secureCost : 0),
            installmentTotalGrossAmountInsurance: entity.quotations[0].financedTotalGrossAmount,
            installmentAndInsuranceTotalGrossAmount: entity.quotations[0].installmentAndInsuranceGrossAmount,
            installmentAndInsuranceFirstGrossAmount: entity.quotations[0].installmentAndInsuranceFirstGrossAmount,
            installmentAndInsuranceLastGrossAmount: entity.quotations[0].installmentAndInsuranceLastGrossAmount,
            financedAndInsuranceTotalGrossAmount: entity.quotations[0].financedAndInsuranceTotalGrossAmount,

            currencyCode: entity.quotations[0].currencyCode,
            residualValue: entity.toBeFinancedElement.residualValueGrossAmount,
            vat: entity.quotations[0].aprcRate,
            paymentProtectionInsurance: true, //TODO,
            financialProduct: {
                id: entity.financialProduct.id,
                name: entity.financialProduct.name
            },
            financialProducts: null,
            formalizationFee: {
                type: entity.financialProduct.rateType[0],
                amount: entity.quotations[0].fixedCosts[0].grossAmount,  //TODO Net o gross
                percentage: entity.quotations[0].fixedCosts[0].rate
            },
            duration: entity.quotations[0].duration.toString(),
            downPaymentGrossAmount: entity.toBeFinancedElement.downPaymentGrossAmount,
            annualMileages: entity.toBeFinancedElement.annualMileage,
            secureCost: entity.toBeFinancedElement.secureCost,
            promotion: entity.toBeFinancedElement.promotion,
            material: entity.toBeFinancedElement.material,
            arrangementFeeCode: entity.toBeFinancedElement.arrangementFeeCode,
            deferralType: entity.toBeFinancedElement.deferralType,
        }
    }

    ////// MOCKS //////



    ////// END MOCKS //////
}